<!--/*
 * Copyright (c) 2020 The Awareness Company. All rights reserved. 
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential.
 */ -->
<template>
  <apexchart type="line" height="310" :options="chartOptions" :series="series" />
</template>

<script>
export default {
  name: "CasesSAProvLinear",
  data: () => ({
    series: [
      {
        name: "Logarithmic",
        data: []
      },
      {
        name: "Logarithmic",
        data: []
      },
      {
        name: "Logarithmic",
        data: []
      },
      {
        name: "Logarithmic",
        data: []
      },
      {
        name: "Logarithmic",
        data: []
      },
      {
        name: "Logarithmic",
        data: []
      },
      {
        name: "Logarithmic",
        data: []
      },
      {
        name: "Logarithmic",
        data: []
      },
      {
        name: "Logarithmic",
        data: []
      }
    ],
    chartOptions: {
      theme: {
        mode: "dark",
        palette: "palette10"
      },
      colors: ["#e91e63", "#A300D6", "#008FFB", "#F86624", "#d6c51b", "#61c1a1", "#53aeb6", "#da80b1", "#28b4c9"],
      chart: {
        background: "rgb(28, 42, 82)",
        foreColor: "rgb(212, 212, 212)",
        toolbar: {
          show: true,
          tools: {
            download: false,
            selection: false
          },
          autoSelected: "zoom"
        }
      },
      grid: {
        borderColor: "rgb(27, 36, 77)"
      },
      legend: {
        show: true,
        position: "bottom",
        itemMargin: {
          vertical: 10
        }
      },
      markers: {
        size: 0
      },
      xaxis: {
        type: "datetime",
        labels: {
          style: {
            fontSize: "10px"
          }
        }
      },
      stroke: {
        width: [2, 2, 2, 2, 2, 2, 2, 2, 2]
      },      
      yaxis: [
        {
          min: 1,
          //logarithmic: true,
          //tickAmount: 5,
          //max: 10000,
          forceNiceScale: true
        }
      ],
      tooltip: {
        x: {
          show: true,
          format: "dd MMM"
        }
      }
    }
  }),
  methods: {
    loadCases(data, provinceDisplay) {
      this.series[0].data = [];

      var provCounts = {};

      var provs = [];
      //first get all the distinct provinces
      provs = Array.from(new Set(data.map(cas => cas.region))).map(province => {
        return province;
      });

      for (var i = 0; i < provs.length; i++) {
        if(provs[i] !== "National" && provs[i] !== "Unknown") {
          provCounts[provs[i]] = null
        }
      }

      //check if only one prov selected
      if(provinceDisplay && provinceDisplay !== "") {
        provCounts = {}
        provCounts[provinceDisplay] = null
      }

      //set the series
      var ser = [];

      for (var key in provCounts) {
        var serData = this.getProvGraph(data, key)

        //get the latest cumulative count
        var tot = 0
        if(serData.length > 0) {
          tot = serData[serData.length -1][1]
        }

        ser.push({name:key, data:serData, count: tot})
      }

      //assign the fixed colors
      //first sort by name
      ser = ser.sort(function(a, b) {
        a = a.name;
        b = b.name;
        return a < b ? -1 : a > b ? 1 : 0;
      });

      var colors = ["#008FFB","#d6c51b","#A300D6","#F86624","#da80b1","#61c1a1","#53aeb6","#28b4c9","#e91e63"]

      //assign the new color
      for (var i = 0; i < ser.length; i++) {  
       ser[i].color = colors[i]
      }

      //sort by count desc
      ser = ser.sort(function(a, b) {
        a = a.count;
        b = b.count;
        return a > b ? -1 : a < b ? 1 : 0;
      });

      //get the new colors order
      var newColors = []
      for (var i = 0; i < ser.length; i++) {  
        newColors.push(ser[i].color)
      }

      //check for single series
      if(ser.length === 1) {
        newColors = ["#e91e63"]
      }
      
      //set the graph data
      this.chartOptions = {
        colors: newColors
      };

      this.series = ser;
    },
    getProvGraph(casesData, provinceDisplay) {
      var dates = [];
      //first get all the distinct dates
      dates = Array.from(new Set(casesData.map(cas => cas.date))).map(date => {
        return date;
      });

      var serData = []

      for (var i = 0; i < dates.length; i++) {
        var thisDate = dates[i];

        //CONFIRMED
        var match = casesData.find(c => c.date === thisDate && c.region === provinceDisplay)
        var confirmed = match.confirmed*1;

        //push to array
        serData.push([
          this.$moment(thisDate, "DD/MM/YYYY")
            .add(10, "hours")
            .toDate(),
          confirmed
        ]);
      }

      return serData
    },
    resize() {
      let self = this;
      this.$nextTick().then(function() {
        self.chartOptions = {
          chart: {
            height: "310"
          }
        }
      })
    }
  }
};
</script>
